import React, { Component } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Card, CardBody, Input, Button } from "reactstrap";
import { Link } from "react-router-dom";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Switch from "react-switch";
import Parse from 'parse';



const expandRow = {
  renderer: row => (
    <>
      Action :
      <Link to="#" className="mr-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
      <Link to="#" className="text-danger" ><i className="mdi mdi-trash-can font-size-18"></i></Link>
    </>
  ),
  showExpandColumn: true,
  expandByColumnOnly: true
};

class LatestTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    }
  }

  render() {
    const data = {
      columns: [
        {
          dataField: 'id',
          text: 'No.'
        },
        {
          dataField: "orderId",
          text: "Order ID"
        },
        {
          dataField: "date",
          text: "Date"
        },
        {
          dataField: "billingName",
          text: "Billing Name"
        },
        {
          dataField: "total",
          text: "Total"
        },
        {
          dataField: "status",
          text: "Payment Status"
        },
      ],
      rows: [
        {
          id: 1,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1572</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 2,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1571</Link>,
          date: "03 Apr, 2020",
          billingName: "Jimmy Barker",
          total: "$165",
          status: <div className="badge badge-soft-warning font-size-12">unpaid</div>,
        },
        {
          id: 3,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1570</Link>,
          date: "03 Apr, 2020",
          billingName: "Donald Bailey",
          total: "$146",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 4,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1569</Link>,
          date: "02 Apr, 2020",
          billingName: "Paul Jones",
          total: "$183",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 5,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1568</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-danger font-size-12">Chargeback</div>,
        },
        {
          id: 6,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1567</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-warning font-size-12">unpaid</div>,
        },
        {
          id: 7,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1566</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 8,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1565</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 9,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1564</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
        {
          id: 10,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1563</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-warning font-size-12">unpaid</div>,
        },
        {
          id: 11,
          orderId: <Link to="#" className="text-dark font-weight-bold">#NZ1562</Link>,
          date: "04 Apr, 2020",
          billingName: "Walter Brown",
          total: "$172",
          status: <div className="badge badge-soft-success font-size-12">Paid</div>,
        },
      ]
    };

    const options = {
      // pageStartIndex: 0,

      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      sizePerPageList:
        [{
          text: '5th', value: 5
        }, {
          text: '10th', value: 10
        }, {
          text: 'All', value: data.rows.length
        }]

    };

    const selectRow = {
      mode: 'checkbox',
      clickToSelect: true
    };

    function Offsymbol(text) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingRight: 2
          }}
        >
          {" "}
          {text}
        </div>
      );
    };

    function OnSymbol(text) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "#fff",
            paddingLeft: "15px"
          }}
        >
          {" "}
          {text}
        </div>
      );
    };


    // Parse server testing functions

    const testFunction = () => {

      const newEntry = new Parse.Object("Student_xx22xx");
      // const newEntry = new Parse.Object("Post");

      newEntry.set("name", "hello");
      // newEntry.set("body", "hello");
      newEntry.save()
    }

    const testCloud = async () => {
      let result = await Parse.Cloud.run("genrateQrCode")


    }

    const testSaveall = async () => {
      var Post_Object = Parse.Object.extend("Post");
      let data = [{ body: "1", address: "address_1" }, { body: "2", address: "address_2" },
      { body: "3", address: "address_3" }, { body: "4", address: "address_4" }
      ]
      var posts = [];
      data.map((item) => {
        var post = new Post_Object();
        post.set("address", item.address);
        post.set("body", item.body);
        posts.push(post);
      })

      Parse.Object.saveAll(posts);

    }

    const AddAfterSave = async () => {
      let result = await Parse.Cloud.run("addAfterSave")

    }

    const fileUploade = async () => {
      let photo = "data:image/png;base64,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"
      const updateEntry = new Parse.Object("Post");
      // const mainQuery = new Parse.Query("Post");
      // mainQuery.equalTo("objectId", "cWa6R9HGvl");
      // let findStudent = await mainQuery.find();
      // let f = findStudent[0].get("photo")
      // f.destroy()
      const base64 = photo
      const parseFile = new Parse.File("student.png", { base64: base64 });
      let newfile = await parseFile.save()
      // updateEntry.set("objectId", "D0LfQGtjgC")
      // updateEntry.set("objectId","I8PRWvcLj1")
      updateEntry.set("body", "manishssss")
      updateEntry.set("address", "suratss")
      updateEntry.set("photo", newfile);
      updateEntry.save()
    }

    const deletePostClass = async () => {
      // let result = await Parse.Cloud.run("removeAllStudent")

      // // const updateEntry = new Parse.Object("Post");
      // updateEntry.set("objectId", "18WSF1e0os")
      // updateEntry.destroy()

      const updateEntry = new Parse.Object("Student_xx11xx");
      updateEntry.set("objectId", "QdFyhh8zdY")
      updateEntry.destroy()
    }

    return (
      <React.Fragment>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Dropdown isOpen={this.state.menu} toggle={() => this.setState({ menu: !this.state.menu })} className="float-right">
                <DropdownToggle tag="i" className="arrow-none card-drop">
                  <i className="mdi mdi-dots-vertical"></i>
                </DropdownToggle>
                <DropdownMenu right>


                  <DropdownItem>Export Report</DropdownItem>

                  <DropdownItem>Print</DropdownItem>

                </DropdownMenu>
              </Dropdown>
              <div className="float-left mb-3 mr-2">
                <select className="custom-select custom-select-sm">
                  <option defaultValue>Class-All</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>
              <div className="float-left">
                <select className="custom-select custom-select-sm">
                  <option defaultValue>Division-All</option>
                  <option value="1">A</option>
                  <option value="2">B</option>
                  <option value="3">C</option>
                </select>
              </div>
              <Col md={12}>
                <div className="form-inline float-md-right">
                  <div className="search-box ml-2">
                    <div className="position-relative">
                      <Input type="text" className="form-control-sm rounded" placeholder="Search..." />
                      <i className="mdi mdi-magnify search-icon" style={{ lineHeight: "30px" }}></i>
                    </div>
                  </div>
                </div>


                <div className="float-left ml-2">
                  <label>Present :  </label>
                  <Switch
                    uncheckedIcon={Offsymbol("No")}
                    checkedIcon={OnSymbol("Yes")}
                    onColor="#f8b425"
                    // width={80}
                    height={20}
                    onChange={() =>
                      this.setState({ switch7: !this.state.switch7 })
                    }
                    checked={this.state.switch7}
                    className="mr-1 mt-1"
                  />
                </div>

                <div className="float-left">
                  <label>Absent :  </label>
                  <Switch
                    uncheckedIcon={Offsymbol("No")}
                    checkedIcon={OnSymbol("Yes")}
                    onColor="#ec4561"
                    // width={80}
                    height={20}
                    onChange={() =>
                      this.setState({ switch7: !this.state.switch7 })
                    }
                    checked={this.state.switch7}
                    className="mr-1 mt-1"
                  />
                </div>

                <div className="float-right">

                  <Button
                    color="primary"
                    size="sm"
                    className="waves-effect waves-light mr-1 ml-2"
                    onClick={() => { deletePostClass() }}
                  >
                    <i className="ri-contacts-line align-middle ml-2"></i>Delete Post
                  </Button>


                  <Button
                    color="primary"
                    size="sm"
                    className="waves-effect waves-light mr-1 ml-2"
                    onClick={() => { AddAfterSave() }}
                  >
                    <i className="ri-contacts-line align-middle ml-2"></i>Add Aftesave on newly Class
                  </Button>

                  <Button
                    color="primary"
                    size="sm"
                    className="waves-effect waves-light mr-1 ml-2"
                    onClick={() => { testCloud() }}
                  >
                    <i className="ri-contacts-line align-middle ml-2"></i>Test Cloud
                  </Button>

                  <Button
                    color="primary"
                    size="sm"
                    className="waves-effect waves-light mr-1 ml-2"
                    onClick={testSaveall}
                  >
                    <i className="ri-contacts-line align-middle ml-2"></i> import Students
                  </Button>

                  <Button
                    color="success"
                    size="sm"
                    className="waves-effect waves-light mr-1"
                    onClick={testFunction}
                  >
                    <i className="ri-user-add-line align-middle ml-2"></i> Add Students
                  </Button>
                  <Button
                    color="success"
                    size="sm"
                    className="waves-effect waves-light mr-1"
                    onClick={fileUploade}
                  >
                    <i className="ri-user-add-line align-middle ml-2"></i> Upload File
                  </Button>
                </div>


              </Col>


              {/* <h4 className="card-title mb-4">Latest Transactions</h4> */}

              <BootstrapTable
                keyField='id'
                data={data.rows}
                columns={data.columns}
                expandRow={expandRow}
                pagination={paginationFactory(options)}
                selectRow={selectRow}
                wrapperClasses="table-responsive"
              />
            </CardBody>
          </Card>
        </Col>
      </React.Fragment >
    );
  }
}

export default LatestTransactions;